










import { Component, Mixins } from 'vue-property-decorator'
import { LoginMixin } from './LoginMixin'
import SingPassLoginQR from '@core/pages/SingPassLoginQR.vue'
import AdminLogin from '@core/pages/AdminLogin.vue'

@Component({
  components: {
    SingPassLoginQR,
    AdminLogin
  }
})
export default class Login extends Mixins(LoginMixin) {
}
